import { IconCheckCircle } from "../../../../common/icons/IconCheckCircle/IconCheckCircle";
import { IconRedCircleX } from "../../../../common/icons/IconRedCircleX/IconRedCircleX";
import LeafCircleLoader from "../../../../common/leaf/LeafLoadingSkeleton/LeafCircleLoader/LeafCircleLoader";
import LeafRectangleLoader from "../../../../common/leaf/LeafLoadingSkeleton/LeafRectangleLoader/LeafRectangleLoader";
import { getShortMonth } from "../../../../common/util/period";
import { SSIEligibility, SSIEligibilityMonth } from "../../../../services/StrongStart/ssiAPI.types";
import { storedLocale } from "../../../Authentication/util";
import "./EligibilityMonthsRow.scss";

export const EligibilityMonthsRow = ({
  eligibilityWindow,
  isLoading,
}: {
  eligibilityWindow: SSIEligibility;
  isLoading: boolean;
}) => {
  const months = [...eligibilityWindow.CurrentYear, ...eligibilityWindow.NextYear];
  const getCheckmark = (month: SSIEligibilityMonth) => {
    switch (month.BadgeType) {
      case "earned":
        return <IconCheckCircle size="md" color="green" solidCheckCircle />;
      case "notEarned":
        return <IconRedCircleX />;
      default:
        return <IconCheckCircle size="md" color="gray" />;
    }
  };

  return isLoading ? (
    <div className="EligibilityMonthsRow">
      {[1, 2, 3].map((month) => {
        return (
          <div className="EligibilityMonthsRow__monthGroup" key={`EligibilityMonthsRowLoader-${month}`}>
            <span className="EligibilityMonthsRow__month">
              <LeafRectangleLoader isLoading={true} height="1rem" margin="0" width="2.5rem" />
            </span>
            <LeafCircleLoader isLoading={true} height="1.5rem" width="1.5rem" />
          </div>
        );
      })}
    </div>
  ) : (
    <div className="EligibilityMonthsRow">
      {months.map((month, ind) => {
        return (
          <span key={`EligibilityMonthsSpan-${month.Period}`}>
            {ind <= 2 && (
              <div className="EligibilityMonthsRow__monthGroup" key={`EligibilityMonths-${month.Period}`}>
                <span className="EligibilityMonthsRow__month">{getShortMonth(month.Period, storedLocale())}</span>
                {getCheckmark(month)}
              </div>
            )}
          </span>
        );
      })}
    </div>
  );
};
